export const stringSkip = ({ str, length }) => {
  if (str.length > length) {
    // length 전의 공백을 찾아서 거기까지 쓰고 ... 붙이기
    let i = length - 1;
    while (str[i] !== " ") i--;
    return str.slice(0, i + 1) + "...";
  } else {
    return str;
  }
};

export const formatPrice = (
  price,
  {
    currencyCode = sessionStorage.getItem("currency"),
    showCurrency = true,
  } = {},
) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currencyCode.toUpperCase(),
  });

  return formatter
    .formatToParts(price)
    .map((part) => {
      if (part.type === "currency") {
        return showCurrency ? part.value + " " : "";
      }
      return part.value;
    })
    .join("")
    .trim();
};

export const formatNumber = (number) => {
  if (number === null || number === undefined || number === "") return "";

  const str = String(number);

  if (isNaN(Number(str.replace(/,/g, "")))) return str;

  // 음수 기호 분리
  const isNegative = str.startsWith("-");
  const absStr = isNegative ? str.slice(1) : str;

  const [intPart, decimalPart] = absStr.split(".");
  const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const result =
    decimalPart !== undefined ? `${withCommas}.${decimalPart}` : withCommas;

  return isNegative ? `-${result}` : result;
};
